<template>
  <section class="p-1">
    <!-- <bread-crumb :bread-crumbs="['Compliance', 'List of Customers']" /> -->

    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Customers List</div>
        <div>
          <bread-crumb :bread-crumbs="['List of Customers']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <loading
          :active="isloadagents"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-form>
          <v-row row-gutters class="mt-1">
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                :items="[
                  { text: 'Individual', value: 'IND' },
                  { text: 'Bussiness', value: 'BUS' },

                  { text: 'All', value: 'ALL' },
                ]"
                placeholder="Customer Type"
                v-model="searchInputs.customer_type"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                :items="listOfFilters"
                v-model="userSelectedFilter"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                :placeholder="
                  userSelectedFilter === 'Customer Name'
                    ? 'Enter Customer Name'
                    : 'Enter Customer ID'
                "
                v-model="searchInputs.customer_id"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <div class="d-flex">
              <div>
                <v-btn
                  depressed
                  small
                  class="mx-2 ms-3 primary text-capitalize"
                  @click="getRemitteList()"
                  >Get Results</v-btn
                >
              </div>
            </div>
          </v-row>
        </v-form>
        <v-row row-gutters class="">
          <!-- <v-col cols="12" lg="2" xs="12"> <v-btn depressed  class="mx-5 mt-2 text-capitalize" color="primary" 
                @click="$router.push('/compliance/users/addCustomer')"
                 outlined>
                <v-icon small>mdi-plus</v-icon> Add Customer
              </v-btn></v-col> -->

          <!-- <v-spacer></v-spacer>outlined
              <v-col cols="12" md="1" xs="12">
              <v-btn depressed  class="mx-2 primary text-capitalize"  @click="getRemitteList">Search</v-btn></v-col>
              <v-col cols="12" md="1" xs="12"><v-btn depressed  class=" ms-0  text-capitalize"   color="primary" @click="clear">Clear</v-btn>
            </v-col> -->
        </v-row>
        <v-row row-gutters class="mt-3">
          <v-spacer></v-spacer>
          <v-col cols="12" lg="4" xs="12">
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <v-card-text>
          <v-row row-gutters>
            <v-col cols="12" lg="8" xs="12"></v-col>
            <v-col cols="12" lg="4" xs="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                single-line
                hide-details
                dense clearable
              ></v-text-field>
            </v-col>        
        </v-row>
        </v-card-text> -->

      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records."
        item-key="user_id"
        dense
      >
        <!-- show-select
          :single-select="singleSelect" -->
        <template v-slot:item.user_type="{ item }">
          <!-- <span :class="item.User_Type == 'IND' ? 'blue--text' : 'orange--text'">{{ item.user_type_name }}</span> 
             <v-btn depressed  :class="item.User_Type == 'IND' ? 'blue' : 'orange'" text small>{{ item.user_type_name }}</v-btn> -->

          <!-- <div
              :color="item.user_type == 'IND' ? 'blue' : 'orange'"
              dark
              label
              small
              outlined
            >
              {{ item.user_type }}
            </div> -->
          <v-chip
            label
            small
            outlined
            :color="item.user_type == 'Individual' ? 'primary' : 'secondary'"
          >
            {{ item.user_type }}
          </v-chip>
        </template>

        <!-- <template v-slot:item.account_status="{ item }">
            <span v-if="item.account_status" class="green--text">Active</span>
            <span v-else class="red--text">Inactive</span>
          </template> -->

        <template v-slot:item.Risk="{ item }">
          {{ getRiskLabel(item.Risk) }}
        </template>

        <template v-slot:item.Is_Negativelisted="{ item }">
          <v-icon :color="item.Is_Negativelisted === 2 ? 'red' : 'green'"
            >mdi-flag</v-icon
          >
        </template>

        <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <listOverviewVue :selectedRemitee="item" />
            </td>
          </template> -->

        <template v-slot:item.action="{ item }">
          <v-icon
            color="grey"
            title="View Details"
            class="mr-2"
            @click="nextpage(item)"
          >
            mdi-chevron-right-circle
          </v-icon>
        </template>
      </v-data-table>
      <!-- <v-toolbar elevation="0">
          <v-spacer></v-spacer>
          <span class="d-flex">
            <span class="select-width me-6 mt-1">
              <v-select
                hide-details
                v-model="itemsPerPage"
                :items="['10', '20', 'All']"
              ></v-select>
            </span>
            <span class="mt-3 me-3">
              0-{{ itemsPerPage }} of {{ userList.length }}
            </span>
            <v-btn depressed  fab icon small>
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn depressed  fab icon small>
              <v-icon>mdi-chevron-right-circle</v-icon>
            </v-btn>
          </span>
        </v-toolbar> -->
      <!-- <v-btn depressed  @click="nextPage">Next Page</v-btn> -->
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
// import listOverviewVue from "../../../components/compliance/users/list-overview.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import userService from "@/services/UserService/userService.js";
export default {
  name: "List of Customers",
  data: () => {
    return {
      itemsPerPage: "10",
      headers: [
        { text: "Customer ID", value: "user_id" },
        { text: "Customer Name", value: "name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: 'Partner', value: 'partner_name'},
        { text: "Nationality", value: "nationality" },
        { text: "Phone Number", value: "mobile_number" },
        { text: "Onboard Status", value: "kyc_status" },
        { text: "Account Status", value: "account_status" },
        { text: "Risk Status", value: "risk_status" },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 150,
          align: "center",
        },
        // { text: 'Fraudulent', value: 'Is_Negativelisted', width: 80 }
        // { text: '', value: 'data-table-expand' },
      ],
      userList: [],
      tatalcustomerslist: [],
      search: "",
      listOfFilters: ["Customer Name", "Phone Number"],
      userSelectedFilter: "Customer Name",
      expanded: [],
      singleExpand: true,
      isloadagents: false,
      skip: 0, // Initial skip value
      limit: 1000, // Initial limit value
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
      searchInputs: {
        fromdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        todate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
    };
  },
  components: {
    BreadCrumb,
    // listOverviewVue
    Loading,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },
  watch: {
    userSelectedFilter(val) {
      if (val === "Customer ID") {
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Customer Name") {
        this.searchInputs.customer_id = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "ID Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Email ID") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Phone Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
      } else {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      }
    },
  },
  mounted() {
    if (this.isPreviousState) {
      const previousState = this.isPreviousState;
      this.searchInputs.customer_type =
        previousState.customer_type === "ALL"
          ? null
          : previousState.customer_type;
      this.searchInputs.customer_id = previousState.customer_id;
      this.searchInputs.customer_name = previousState.customer_name;
      this.searchInputs.id_number = previousState.id_number;
      this.searchInputs.user_email = previousState.user_email;
      this.searchInputs.phone_number = previousState.phone_number;
      this.searchInputs.account_status =
        previousState.account_status === "All"
          ? null
          : previousState.account_status;
      this.searchInputs.kyc_status =
        previousState.kyc_status === "ALL" ? null : previousState.kyc_status;
      this.searchInputs.from_date = previousState.from_date;
      this.searchInputs.to_date = previousState.to_date;
      this.searchInputs.txn_from_date = previousState.txn_from_date;
      this.searchInputs.txn_to_date = previousState.txn_to_date;
      this.getRemitteList();
    }
    console.log("queryery", this.$route.query.Totalcus_rejected);
    console.log(this.$store.state);
    if (this.$route.query.All_Customers) {
      this.totalcuslist();
    }
    if (this.$route.query.Todayreg_Customers) {
      this.todayRegcuslist();
    }
    if (this.$route.query.IND_Customers) {
      this.totalINDcuslist();
    }
    if (this.$route.query.BUS_Customers) {
      this.totalBUScuslist();
    }
    if (this.$route.query.Totalcus_rejected) {
      this.totalRejectedcus();
    }
    if (this.$route.query.INDCus_rejected) {
      this.INDRejectedcus();
    }
    if (this.$route.query.BUSCus_rejected) {
      this.BUSRejectedcus();
    }
    if (this.$route.query.All_approval) {
      this.getAllaproval();
    }
    if (this.$route.query.IND_approval) {
      this.getAllaprovalIND();
    }
    if (this.$route.query.BUS_approval) {
      this.getAllaprovalBUS();
    }
    if (this.$route.query.All_hold) {
      this.getAllhold();
    }
    if (this.$route.query.IND_hold) {
      this.getAllholdIND();
    }
    if (this.$route.query.BUS_hold) {
      this.getAllholdBUS();
    }
    this.logComponentPath();
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
    logComponentPath() {
      const currentPath = this.$route.path;
      console.log("Current Component Path:", currentPath);
    },
    validateFromDate(value) {
      if (value && this.searchInputs.to_date) {
        return (
          value <= this.searchInputs.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.searchInputs.from_date) {
        return (
          value >= this.searchInputs.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    validateFromTxnDate(value) {
      if (value && this.searchInputs.txn_to_date) {
        return (
          value <= this.searchInputs.txn_to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToTxnDate(value) {
      if (value && this.searchInputs.txn_from_date) {
        return (
          value >= this.searchInputs.txn_from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
      }
    },

    // nextPage() {
    //   this.skip += this.limit; // Increase skip value by the current limit
    //   this.getRemitteList(); // Fetch the next page of results
    // },
    async getRemitteList() {
      this.isloadagents = true;
      console.log("rrr", this.searchInputs.customer_type);
      try {
        const params = {
          customer_type: this.searchInputs.customer_type
            ? this.searchInputs.customer_type
            : "ALL",
          customer_id: this.searchInputs.customer_id,
          customer_name: this.searchInputs.customer_name,
          id_number: this.searchInputs.id_number,
          user_email: this.searchInputs.user_email,
          phone_number: this.searchInputs.phone_number,
          account_status: this.searchInputs.account_status
            ? this.searchInputs.account_status
            : "All",
          kyc_status: this.searchInputs.kyc_status
            ? this.searchInputs.kyc_status
            : "ALL",
          from_date: this.searchInputs.from_date,
          to_date: this.searchInputs.to_date,
          txn_from_date: this.searchInputs.txn_from_date,
          txn_to_date: this.searchInputs.txn_to_date,
          skip: this.skip,
          limit: this.limit,
        };
        const response = await userService.getRemittenceList(params);
        if (response.status === 200) {
          this.isloadagents = false;
          this.userList = response.data.data;
          // to store the state of the page (handle page when route back )
          this.$store.dispatch("savePreviousPageState", {
            customer_type: this.searchInputs.customer_type
              ? this.searchInputs.customer_type
              : "ALL",
            customer_id: this.searchInputs.customer_id,
            customer_name: this.searchInputs.customer_name,
            id_number: this.searchInputs.id_number,
            user_email: this.searchInputs.user_email,
            phone_number: this.searchInputs.phone_number,
            account_status: this.searchInputs.account_status
              ? this.searchInputs.account_status
              : "All",
            kyc_status: this.searchInputs.kyc_status
              ? this.searchInputs.kyc_status
              : "ALL",
            from_date: this.searchInputs.from_date,
            to_date: this.searchInputs.to_date,
            txn_from_date: this.searchInputs.txn_from_date,
            txn_to_date: this.searchInputs.txn_to_date,
            skip: this.skip,
            limit: this.limit,
          });
        } else {
          this.isloadagents = false;
        }
      } catch (error) {
        this.isloadagents = false;

        console.error(error);
      }
    },

    async totalcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async todayRegcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayRegCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("todayRegcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalINDcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalINDcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalBUScuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalBUScuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.totalRejectedcus();
        // }
        console.log("totalRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async INDRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.INDRejectedcus();
        // }
        console.log("INDRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async BUSRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.BUSRejectedcus();
        // }
        console.log("BUSRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaproval() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaproval", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllhold() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getAllHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllhold();
        // }
        console.log("getAllhold", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllholdIND();
        // }
        console.log("getAllholdIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllholdBUS();
        // }
        console.log("getAllholdBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },

    getRiskLabel(riskVal) {
      if (riskVal >= 0 && riskVal <= 50) {
        return "Low risk";
      } else if (riskVal > 50 && riskVal <= 80) {
        return "Medium risk";
      } else {
        return "High risk";
      }
    },
    nextpage(item) {
      console.log("data ", item);
      this.$router.push({
        name: "Transactions",

        query: {
          id: item.customer_id,
          customerid: item.customer_id,
          user_type: item.user_type,
        },
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
      sessionStorage.setItem("Benecustomer_id",item.customer_id)
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
</style>
